import * as API from 'app/services/http/personalReference'

export function fetchPersonalReferenceReviewByShortCode(shortCode) {
  return () => {
    return API.fetchPersonalReferenceReviewByShortCode(shortCode)
  }
}
